import React, { useState } from 'react'
import { TransactionsRequest } from '../../../../../services/api/transactions'
import { useFormikContext } from 'formik'
import { RangeValue } from 'rc-picker/lib/interface'
import { Moment } from 'moment'
import { displayIso } from '../../../../../utils/formatter'
import { View } from './View'

export const Container: React.FunctionComponent = () => {
  const { setFieldValue } = useFormikContext<TransactionsRequest>()
  const [ranges, setRanges] = useState<RangeValue<Moment>>()

  const onRangesChange = (values: RangeValue<Moment>) => {
    setRanges(values)
    const createdAtFrom: string | null = values
      ? displayIso((values[0] as Moment).startOf('day'))
      : null
    const createdAtTo: string | null = values
      ? displayIso((values[1] as Moment).endOf('day'))
      : null
    setFieldValue('createdAtFrom', createdAtFrom)
    setFieldValue('createdAtTo', createdAtTo)
  }

  return <View ranges={ranges} setRanges={onRangesChange} />
}
